import React, { useCallback, useEffect, useState } from 'react'
import { FourthStepEl } from '../Elements'
import GroupRegistrationStore from '../Store/GroupRegistrationStore'
import KeyboardBackspaceIcon from '@material-ui/icons/KeyboardBackspace'
import Input from '../../../../../../../Components/Input/Input'
import { H5 } from '../../../../../../../Styles/typography'
import Button from '../../../../../../../Components/Buttons/Button'
import Uppy from '@uppy/core'
import AwsS3 from '@uppy/aws-s3'
import ms from 'ms'
import { notify } from '../../../../../../../Helpers/Notifications'
import ReactPlayer from 'react-player'
import Batch from './Batch'

function FourthStep({ batches, onSubmit, withAuditionVid }) {
  const {
    back,
    videoBlob,
    message,
    selBatch,
  } = GroupRegistrationStore.useContainer()
  const [submitting, setSubmitting] = useState(false)

  const uppy = new Uppy({
    debug: true,
    autoProceed: true,
    restrictions: {
      maxFileSize: 50 * 1024 * 1024,
      maxNumberOfFiles: 1,
      allowedFileTypes: ['video/*'],
    },
    onBeforeUpload: () => {
      setSubmitting(true)
    },
  }).use(AwsS3, {
    timeout: ms('5 minute'),
    companionUrl: process.env.REACT_APP_API_URL,
  })

  const addFile = useCallback(
    (file) => {
      try {
        uppy.addFile({
          name: file.name,
          type: file.type,
          data: file,
        })
        return true
      } catch (err) {
        notify('error', err.message)
      }
    },
    [uppy],
  )

  useEffect(() => {
    uppy
      .on('upload-success', async (file, response) => {
        const success = await onSubmit(
          message,
          batches[selBatch].id,
          response.uploadURL,
        )
        if (success) setSubmitting(false)
      })
      .on('upload-error', (file, error) => {
        notify('error', error.message)
      })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [uppy])

  return (
    <>
      <div className='back-btn' onClick={() => back()}>
        <KeyboardBackspaceIcon /> Back
      </div>
      <FourthStepEl>
        <div className='content'>
          <div className='preview'>
            <div className='batch-info'>
              <H5 bold>Selected Batch:</H5>
              <Batch withAction={false} batch={batches[selBatch]} />
            </div>
            <div className='right'>
              <div className='enroll-message'>
                <H5 bold>Message:</H5>
                <Input
                  type='textarea'
                  name='enrollMessage'
                  value={message}
                  onChange={() => {}}
                  placeholder={'Message'}
                  disabled={true}
                />
              </div>
              {withAuditionVid && (
                <div className='video-player'>
                  <H5 bold>Audition Video:</H5>
                  <ReactPlayer
                    url={URL.createObjectURL(videoBlob)}
                    controls
                    playing
                    width={'100%'}
                  />
                </div>
              )}
            </div>
          </div>

          <div className='action-btn'>
            <Button
              type={'primary'}
              name='Submit'
              onClick={async () => {
                if (withAuditionVid) await addFile(videoBlob)
                else {
                  setSubmitting(true)
                  const success = await onSubmit(message, batches[selBatch].id)
                  if (success) setSubmitting(false)
                }
              }}
              disabled={submitting}
              loading={submitting}
            />
          </div>
        </div>
      </FourthStepEl>
    </>
  )
}

export default FourthStep
